import { apiGateway } from "@/_old/services/api-gateway";
export interface Excess3MonthsResponse {
  company_id: number;
  package: {
    id: number;
    total_credits: number;
    credit_unit_price: number;
    total_value: number;
  };
  last_month: {
    month: string;
    excess_value: number;
    excess_percentage: number;
  };
  consumption_percentage_months: Array<{
    month: string;
    consumed_percentage: number;
  }>;
}

/** Initial mock for development until the API is ready */
const MOCK_EXCESS_RESPONSE: Excess3MonthsResponse = {
  company_id: 123,
  package: {
    id: 456,
    total_credits: 6000,
    credit_unit_price: 85,
    total_value: 89000,
  },
  last_month: {
    month: "2026-01",
    excess_value: 800,
    excess_percentage: 0.46,
  },
  consumption_percentage_months: [
    { month: "2026-01", consumed_percentage: 0.6 },
    { month: "2026-02", consumed_percentage: 0.91 },
    { month: "2026-03", consumed_percentage: 0.92 },
    { month: "2026-04", consumed_percentage: 0.92 },
    { month: "2026-05", consumed_percentage: 0.92 },
    { month: "2026-06", consumed_percentage: 0.92 },
    { month: "2026-07", consumed_percentage: 0.92 },
    { month: "2026-08", consumed_percentage: 0.92 },
    { month: "2026-09", consumed_percentage: 0.92 },
    { month: "2026-10", consumed_percentage: 1.03 },
    { month: "2026-11", consumed_percentage: 1.2 },
    { month: "2026-12", consumed_percentage: 1.3 },
  ],
};

/** When true, uses mock instead of real API (for development) */
const USE_MOCK = false;
/**
 * Fetches package excess credits data.
 *
 * - Empty response: client had NO excess → do not show card
 * - With data: client had excess → show card
 *
 * API: GET /packages-excess-credits?company_id={companyId}
 */
export async function fetchExcess3Months(
  companyId: number,
): Promise<Excess3MonthsResponse | null> {
  if (!companyId) {
    return null;
  }

  if (USE_MOCK) {
    return MOCK_EXCESS_RESPONSE;
  }

  try {
    const { data } = await apiGateway.get<Excess3MonthsResponse>(
      `/packages-excess-credits?company_id=${companyId}`,
      {
        headers: {
          "company-id": companyId.toString(),
        },
      },
    );

    return data;
  } catch (error) {
    console.error("Error fetching packages excess credits:", error);
    return null;
  }
}
